import {
  Component,
  OnInit,
  OnDestroy,
  Inject,
  AfterViewInit,
  ChangeDetectorRef
} from '@angular/core';
import * as OktaSignIn from '@okta/okta-signin-widget';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';
import {
  AppDataService,
  CustomLoginService,
  EnrollMFAReq,
  GlobalVariablesService,
  LoginMFAReq,
  LoginMFARes,
  StepRequest,
  StepsService,
  VerifyMFAReq
} from '@tmhcc-ng-lib/data-service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { CustomModalComponent } from 'libs/artisan-edge/src/lib/custom-modal/custom-modal.component';
import { ForgetPasswordComponent } from 'libs/artisan-edge/src/lib/forget-password/forget-password.component';
import { DialogService, DialogConfig } from '@tmhcc-ng-lib/framwork/dialog';
import {
  LoginContentService,
  ResetPasswordService,
  ForgotPasswordService
} from '@tmhcc-ng-lib/content-service';
import { LoginSitecoreContent } from 'libs/content-service/def/login-content';
import { OktaLoginRequest } from '@tmhcc-ng-lib/data-service';
import { appendRelativePathToUrl, getBaseUrl } from '@tmhcc/util';
// import { OktaConfig2 } from '..';
import { OktaAuthService, OktaConfig, OKTA_CONFIG } from '@okta/okta-angular';
import { ResetPasswordComponent } from 'libs/artisan-edge/src/lib/reset-password/reset-password.component';
import { BASE_URI } from 'libs/startup/tokens/base-uri.token';
import { ActivatedRoute, Router } from '@angular/router';
import { IsTrue } from 'libs/util/binary-util';
import { AlertTosterService } from '@tmhcc/framwork/alert-toster';
import { OktaLoginService } from '@tmhcc-ng-lib/okta-service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  LoginFormValidation,
  LoginScreenType,
  LoginSubScreenType,
  Status
} from '@tmhcc-ng-lib/models';
import { StepNevigationService } from '../common-liability/nevigation/step-nevigation.service';

declare var $: any;

@Component({
  selector: 'ae-custom-login',
  templateUrl: './custom-login.component.html',
  styleUrls: ['./custom-login.component.scss']
})
export class CustomLoginComponent implements OnInit, OnDestroy {
  trustedMediaUrl;
  mediaURL = '';
  oktaSignIn;
  token;
  page: any;
  isDataAvailable: boolean = false;
  // modalContent: DialogConfig = this.loginContentService.oktaErrorModal();
  resetPasswordModalContent: DialogConfig = this.resetPasswordService.resetPasswordModal();
  forgetPasswordModalContent: DialogConfig = this.forgotPasswordService.forgotPasswordModal();
  loginData: LoginSitecoreContent;
  signIn;
  isLoading: boolean;

  screenType = '';
  subScreenType = '';
  validationStatus = '';
  validationMessage = '';
  selectedExtension = '';
  smsAuthFormGroup: FormGroup;
  formSubmitted = false;
  phoneNumber = '';
  remeberDevice = false;
  showResendButton = false;

  titleText: string;
  constructor(
    protected configService: AppConfigService,
    private forgotPasswordService: ForgotPasswordService,
    private resetPasswordService: ResetPasswordService,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    public router: Router,
    private loginContentService: LoginContentService,
    private loaderService: LoaderService,
    // public dialogService: DialogService,
    private appDataService: AppDataService,
    private sanitizer: DomSanitizer,
    private loginService: CustomLoginService,
    private globalVarService: GlobalVariablesService,
    private alertService: AlertTosterService,
    private oktaLoginService: OktaLoginService,
    private stepsService: StepsService,
    private stepNevigationService: StepNevigationService
  ) {}

  async onSubmit() {}
  ngOnInit() {
    this.titleService.setTitle('Artisan :: Login');

    this.activatedRoute.queryParams.subscribe(params => {
      let loginMFAReq: LoginMFAReq = {
        QuoteId: params['quoteid'],
        Username: params['username'],
        OktaStatetoken: params['statetoken']
      };
      if (
        !loginMFAReq.QuoteId ||
        !loginMFAReq.Username ||
        !loginMFAReq.OktaStatetoken
      ) {
        this.router.navigate(['/login']);
      }
      this.loaderService.show();
      this.loginService
        .loginMFA(loginMFAReq)
        .subscribe((loginInfo: LoginMFARes) => {
          if (loginInfo.OktaUserStatus === Status.NotFound) {
            this.validationStatus = LoginFormValidation.SESSION_EXPIRED;
            this.loaderService.hide();
          } else if (loginInfo.Status === Status.Success) {
            loginInfo['Username'] = loginMFAReq.Username;
            loginInfo['FactorId'] = loginInfo.FactorId || '';
            this.globalVarService.loginMFAInfo = loginInfo;

            this.screenType = loginInfo.OktaUserStatus;
            this.phoneNumber = loginInfo.Phone;
            this.remeberDevice = loginInfo.RememberDeviceByDefault;

            if (this.screenType === LoginScreenType.VerifySms) {
              this.subScreenType = LoginSubScreenType.CODESEND;
            } else if (this.screenType === LoginScreenType.VerifyVoiceCall) {
              this.subScreenType = LoginSubScreenType.CALL;
            }
            this.showResendButton = true;
            this.loaderService.hide();
          } else {
            this.alertService.error(loginInfo.Errors.join(','));
            loginInfo.Errors.join(','), '', 'toast-top-right', 5000;
            this.loaderService.hide();
          }
        });
    });

    this.smsAuthFormGroup = this.formBuilder.group({
      country: ['', Validators.required],
      phone: ['', Validators.required],
      passCode: ['', Validators.required],
      rememberDevice: ['']
    });

    this.loginContentService.data$.subscribe(res => {
      this.loginContent(res);
      this.appDataService.logoutMsg.next(res.messages[0].description);
    });
  }
  get formControls() {
    return this.smsAuthFormGroup.controls;
  }

  loginContent(data) {
    if (data) {
      this.loaderService.hide();
      this.loginData = data;
      this.isDataAvailable = true;
      const iframURL = this.loginData.media[0].navigation.Url;
      this.trustedMediaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        iframURL
      );
      this.mediaURL = this.trustedMediaUrl;
    }
  }

  appendError(errorMessage) {
    const oktaErrorContainer = $('div[data-se=o-form-error-container]');
    if (!oktaErrorContainer.hasClass('o-form-has-errors')) {
      oktaErrorContainer.addClass('o-form-has-errors');
    }
    oktaErrorContainer.append(
      '<div><div class=okta-form-infobox-error infobox infobox-error role=alert><span class=icon error-16></span><p>' +
        errorMessage +
        '</p></div></div>'
    );
  }

  /** Custom Okta Login Fields */
  customSignInField() {
    const userName = document.getElementsByClassName(
      'o-form-input-name-username'
    );
    if (!userName || !userName.length) return;
    const userNameValue = (<any>userName[0]).querySelector('input').value;
    userName[0].innerHTML =
      '<span data-toggle=tooltip title=Enter email address to login class=input-tooltip icon form-help-16 data-hasqtip=0 aria-describedby=qtip-0></span><span class=icon input-icon person-16-gray></span><input type=text placeholder=Email Address name=Email id=okta-signin-username value=' +
      userNameValue +
      ' aria-label=User ID autocomplete=off>';

    const password = document.getElementsByClassName(
      'o-form-input-name-password'
    );
    password[0].innerHTML =
      '<span data-toggle=tooltip title=Enter a password class=input-tooltip icon form-help-16 data-hasqtip=1></span><span class=icon input-icon remote-lock-16></span><input type=password placeholder=Password placement=top ngbTooltip=Enter a password name=Password id=okta-signin-password value= aria-label=User ID autocomplete=off>';

    if ($('[data-toggle=tooltip]').tooltip()) {
      $('[data-toggle=tooltip]').tooltip();
    }
  }

  ngOnDestroy() {
    if (this.oktaSignIn) this.oktaSignIn.remove();
  }

  resetValidation() {
    this.validationStatus = '';
    this.validationMessage = '';
  }
  SetupMFA(setupType) {
    this.showResendButton = true;
    this.smsAuthFormGroup.reset();
    this.smsAuthFormGroup.controls.country.reset('', {
      countryName: 'Please Select country'
    });
    this.formSubmitted = false;
    this.screenType = LoginScreenType[setupType];
    if (this.screenType === LoginScreenType.EnrollVoice) {
      this.subScreenType = LoginSubScreenType.CALL;
    }
    this.resetValidation();
  }
  SendCode(status) {
    this.resetValidation();
    if (
      this.screenType === LoginScreenType.EnrollSMS ||
      this.screenType === LoginScreenType.EnrollVoice
    ) {
      this.formSubmitted = true;
      if (this.smsAuthFormGroup.controls['country'].invalid) {
        return false;
      }
      if (this.smsAuthFormGroup.controls['phone'].invalid) {
        return false;
      }
      this.enrollMFA(status);
    } else {
      this.sendCode(status);
    }

    this.formSubmitted = false;
  }
  enrollMFA(status) {
    this.loaderService.show();
    this.subScreenType = status;
    let enrollReq: EnrollMFAReq = {
      Username: this.globalVarService.loginMFAInfo.Username,
      OktaId: this.globalVarService.loginMFAInfo.OktaId,
      OktaStateToken: this.globalVarService.loginMFAInfo.OktaStateToken,
      Phone: `${this.selectedExtension}${this.smsAuthFormGroup.value.phone}`
    };
    if (this.screenType === LoginScreenType.EnrollSMS) {
      this.enrollSMS(enrollReq);
    } else if (this.screenType === LoginScreenType.EnrollVoice) {
      this.enrollVoice(enrollReq);
    }
  }

  enrollSMS(enrollSMS) {
    this.loginService.enrollSMS(enrollSMS).subscribe(loginInfo => {
      if (loginInfo.Status === Status.Success) {
        this.showResendButton = false;
        let loginMFARes: LoginMFARes = this.globalVarService.loginMFAInfo;
        loginMFARes.FactorId = loginInfo.FactorId;
        this.globalVarService.loginMFAInfo = loginMFARes;

        this.subScreenType = LoginSubScreenType.CODESENT;
        this.validationStatus = LoginFormValidation.CODE_SENT;
        this.loaderService.hide();
      } else {
        this.handleErrorInfo(
          loginInfo.Errors.join(','),
          LoginFormValidation.INVALID_REQUEST
        );
      }
    });
  }

  enrollVoice(enrollSMS) {
    this.loginService.enrollVoice(enrollSMS).subscribe(loginInfo => {
      if (loginInfo.Status === Status.Success) {
        this.showResendButton = false;
        let loginMFARes: LoginMFARes = this.globalVarService.loginMFAInfo;
        loginMFARes.FactorId = loginInfo.FactorId;
        this.globalVarService.loginMFAInfo = loginMFARes;

        this.subScreenType = LoginSubScreenType.REDIAL;
        this.validationStatus = LoginFormValidation.REDIAL;
        this.loaderService.hide();
      } else {
        this.subScreenType = LoginSubScreenType.REDIAL;
        this.handleErrorInfo(
          loginInfo.Errors.join(','),
          LoginFormValidation.INVALID_REQUEST
        );
      }
    });
  }

  handleErrorInfo(error, status) {
    this.validationStatus = status;
    this.validationMessage = error;
    this.loaderService.hide();
  }
  sendCode(status) {
    this.loaderService.show();
    let verifyMFAReq: VerifyMFAReq = {
      Username: this.globalVarService.loginMFAInfo.Username,
      OktaId: this.globalVarService.loginMFAInfo.OktaId,
      OktaStateToken: this.globalVarService.loginMFAInfo.OktaStateToken,
      FactorId: this.globalVarService.loginMFAInfo.FactorId,
      Passcode: this.smsAuthFormGroup.value.passCode,
      RememberDevice: this.remeberDevice
    };
    this.loginService.verifySMS(verifyMFAReq).subscribe(loginInfo => {
      if (loginInfo.Status === Status.Success) {
        this.showResendButton = false;
        this.subScreenType = status;
        this.validationStatus = LoginFormValidation.CODE_SENT;
        this.loaderService.hide();
      } else {
        this.handleErrorInfo(
          loginInfo.Errors.join(','),
          LoginFormValidation.INVALID_REQUEST
        );
      }
    });
  }
  Verify() {
    this.formSubmitted = true;
    if (this.smsAuthFormGroup.controls['passCode'].invalid) {
      return false;
    }
    this.loaderService.show();
    this.formSubmitted = false;
    let verifyMFAReq: VerifyMFAReq = {
      Username: this.globalVarService.loginMFAInfo.Username,
      OktaId: this.globalVarService.loginMFAInfo.OktaId,
      OktaStateToken: this.globalVarService.loginMFAInfo.OktaStateToken,
      FactorId: this.globalVarService.loginMFAInfo.FactorId,
      Passcode: this.smsAuthFormGroup.value.passCode,
      RememberDevice: this.remeberDevice
    };
    if (this.screenType === LoginScreenType.EnrollSMS) {
      this.activateMFASms(verifyMFAReq);
    } else if (this.screenType === LoginScreenType.EnrollVoice) {
      this.activateMFAVoice(verifyMFAReq);
    } else if (this.screenType === LoginScreenType.VerifySms) {
      this.verifySMSPasscode(verifyMFAReq);
    } else if (this.screenType === LoginScreenType.VerifyVoiceCall) {
      this.verifyVoicePasscode(verifyMFAReq);
    }
  }

  verifySMSPasscode(verifyMFAReq) {
    this.loginService.verifySMS(verifyMFAReq).subscribe(loginInfo => {
      if (loginInfo.Status === Status.Success) {
        this.alertService.success('Successfully verified');
        this.processOkta();
      } else {
        this.handleErrorInfo(
          loginInfo.Errors.join(','),
          LoginFormValidation.INVALID_REQUEST
        );
      }
    });
  }
  activateMFASms(verifyMFAReq) {
    this.loginService.activateSMS(verifyMFAReq).subscribe(loginInfo => {
      if (loginInfo.Status === Status.Success) {
        this.alertService.success('Successfully verified');
        this.processOkta();
      } else {
        this.handleErrorInfo(
          loginInfo.Errors.join(','),
          LoginFormValidation.INVALID_REQUEST
        );
      }
    });
  }

  verifyVoicePasscode(verifyMFAReq) {
    this.loginService.verifyVoice(verifyMFAReq).subscribe(loginInfo => {
      if (loginInfo.Status === Status.Success) {
        this.alertService.success('Successfully verified');
        this.processOkta();
      } else {
        this.handleErrorInfo(
          loginInfo.Errors.join(','),
          LoginFormValidation.INVALID_REQUEST
        );
      }
    });
  }
  activateMFAVoice(verifyMFAReq) {
    this.loginService.activateVoice(verifyMFAReq).subscribe(loginInfo => {
      if (loginInfo.Status === Status.Success) {
        this.alertService.success('Successfully verified');
        this.processOkta();
      } else {
        this.handleErrorInfo(
          loginInfo.Errors.join(','),
          LoginFormValidation.INVALID_REQUEST
        );
      }
    });
  }
  processOkta() {
    const dataCall: OktaLoginRequest = {
      id: this.globalVarService.loginMFAInfo.OktaId,
      username: this.globalVarService.loginMFAInfo.Username
    };

    this.oktaLoginService.processOkta(dataCall).subscribe(
      (data: any) => {
        this.globalVarService.sessionId = data.Token;
        this.token = data.Token;
        this.loginOkta(data);
      },
      err => {
        //throw err;
        this.alertService.error('Please check your username and password and try again.');
      }
    );
  }

  loginOkta(data) {
    const dataCall: OktaLoginRequest = {
      username: this.globalVarService.loginMFAInfo.Username,
      token: data.Token
    };

    this.oktaLoginService.loginOkta(dataCall).subscribe(
      (data: any) => {
        sessionStorage.setItem('userDetails', JSON.stringify(data));
        sessionStorage.setItem('isWrittenCommissionDisplayApplicable', data.IsKraftLake?'N':'Y'); 
        sessionStorage.setItem(
          'UserId',
          this.globalVarService.loginMFAInfo.Username
        );
        this.appDataService.changeStorage.next(data);
        sessionStorage.setItem('token', data.token);
        this.loginService.isAuthenticated.next(true);

        //this.loginService.authClient.session.setCookieAndRedirect(data.Token);
        let payload: StepRequest = {
          policyId: this.globalVarService.loginMFAInfo.PolicyNum.split('-')[0],
          versionNum: this.globalVarService.loginMFAInfo.PolicyNum.split('-')[1]
        };
        this.stepsService.getPolicyDetails(payload).subscribe(res => {
          this.stepNevigationService.stepNevigation(res);
        });
      },
      err => {
        //throw err;
        this.alertService.error('Please check your username and password and try again.');
      }
    );
  }

  onChange(country) {
    console.log(country);
  }
  checkedRemeberDevice() {
    this.remeberDevice = !this.remeberDevice;
  }
  backToAuthOption() {
    this.screenType = LoginScreenType.EnrollMFA;
    this.subScreenType = LoginSubScreenType.RESET;
  }

  countryInfo = [
    {
      countryCode: 'US',
      countryName: 'United States',
      extension: '+1'
    },
    {
      countryCode: 'IN',
      countryName: 'India',
      extension: '+91'
    }
  ];
}

export interface OktaConfig2 extends OktaConfig {
  baseUrl: string;
}
